const SESSION_DP_MULTITAB_COUNT = 'dynpackMultiTabCount';
const SESSION_TAB_FIRST_TIME = 'isLoadedTabFirstTime';
const hasOpenedParentWindow = () => Odigeo._.get(window, 'opener.parent') && !window.opener.closed;
const didTabClose = (tab, timeout = 300) => {
    return new Promise((resolve, reject) => {
        Odigeo._.delay(function() {
            resolve(!tab || tab.closed || typeof tab.closed === 'undefined');
        }, timeout);
    });
};
const isFirstLoadedTab = () => !Odigeo.Utils.parseJson(Odigeo.Session.get(SESSION_TAB_FIRST_TIME));
const checkTabLoaded = () => Odigeo.Session.set(SESSION_TAB_FIRST_TIME, hasOpenedParentWindow());
const getTabCount = () => parseInt(Odigeo.Storage.get(SESSION_DP_MULTITAB_COUNT), 10) || 0;
const setTabCount = (tabCount) => {
    Odigeo.Storage.set(SESSION_DP_MULTITAB_COUNT, tabCount);
    return tabCount;
};
const resetTabCount = () => setTabCount(0);
const incrementTabCount = () => setTabCount(getTabCount() + 1);
const addTabMetadata = (tab, {hotelPosition, tabName, key}) => {
    Object.assign(tab, {
        tabTimerStart: new Date(),
        tabHotelPosition: hotelPosition,
        tabWindowName: tabName,
        accommodationKey: key,
    });
};

module.exports = {
    hasOpenedParentWindow,
    didTabClose,
    isFirstLoadedTab,
    checkTabLoaded,
    getTabCount,
    resetTabCount,
    incrementTabCount,
    addTabMetadata,
};
